module.exports = __webpack_public_path__ + "static/media/whole-word-hover.57bad168.svg";